import styled from 'styled-components';
import { Skeleton, Divider } from 'opencare-crown';

export const SelectSkeleton = styled(Skeleton)`
  && {
    width: 100%;
    margin: ${props => props.margin};
    .ant-skeleton-title {
      height: 34px;
    }
  }
`;

export const DropdownDivider = styled(Divider)`
  && {
    margin: 8px 0;
  }
`;
